import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { UncontrolledTooltip } from 'reactstrap'
import { find } from 'lodash'
import useDonorContactInformation from '../../hooks/useDonorContactInformation'

const MyShortInfo = () => {
  const donorContactInformation = useDonorContactInformation()
  const { user } = useSelector((state) => state.app)

  const { rotateBloodDropOnStartpage, showDonationStatus } = useSelector(
    (state) => state.app.appSettings,
  )

  const translateBloodGroup = (bloodGroup) => {
    bloodGroup = bloodGroup.replace(' pos', '+')
    bloodGroup = bloodGroup.replace(' neg', '-')
    bloodGroup = bloodGroup.replace(' RhD', '')

    return bloodGroup
  }

  const bloodDonationData = find(user?.donorDonationTypeDatas, {
    donationTypeEnum: 'BLOOD',
  })

  const daysLeftToDonate = bloodDonationData?.daysToNextTap || undefined

  const homePostalAddress =
    donorContactInformation.find(({ key }) => key === 'homePostalAddress')?.value || ''

  return user ? (
    <div className="my-short-info">
      <div className={`blood-type ${rotateBloodDropOnStartpage ? 'rotate' : ''}`}>
        <div className="blood-type-text">
          {user.bloodGroup ? translateBloodGroup(user.bloodGroup) : '-'}
        </div>
      </div>
      <div className="person-info">
        <span className="name">
          {user.firstName.replace(/\//g, '')} {user.lastName.replace(/\//g, '')}
        </span>
        <div className="info">
          {user.age && (
            <span>
              {user.age} {__.trans('sidebar.years')}
            </span>
          )}
          {user.age && homePostalAddress && <span>, &nbsp; </span>}
          <span>{homePostalAddress && `${homePostalAddress}`}</span>
        </div>

        {showDonationStatus && (
          <span
            className={classNames('status', {
              'not-ready':
                (daysLeftToDonate > 0 && daysLeftToDonate !== undefined) || !bloodDonationData,
            })}
          >
            <i
              id="info"
              className={classNames(
                'icon',
                bloodDonationData ? 'icon-geblod_ikon_hjarta' : 'icon-geblod_ikon_info',
              )}
            />
            <UncontrolledTooltip placement="bottom" target="info">
              {__.trans('sidebar.you-are-not-ready-info')}
            </UncontrolledTooltip>
            <span>
              {bloodDonationData
                ? __.trans(`sidebar.you-are-ready${daysLeftToDonate ? '-in' : ''}`)
                : __.trans('sidebar.you-are-not-ready')}
              {daysLeftToDonate > 0 && (
                <>
                  {' '}
                  {daysLeftToDonate} {__.trans(`sidebar.day${daysLeftToDonate === 1 ? '' : 's'}`)}
                </>
              )}
            </span>
          </span>
        )}
      </div>
    </div>
  ) : null
}

export default MyShortInfo
